import React from 'react';
import { Box, Divider, Grid, Typography } from '@mui/material';
import StatCard from '../../components/admin/StatCard';
import QuickLinks from '../../components/admin/QuickLinks';
import useAdminStats from '../../hooks/admin/useAdminStats';
import AdminError from '../../components/admin/AdminError';
import AdminLoading from '../../components/admin/AdminLoading';

const statCardsConfig = [
    {
        title: 'Products',
        icon: 'InventoryIcon',
        color: '#e8f4fd',
        link: '/admin/products',
        btnLabel: 'Manage Products',
        key: 'productsCount',
    },
    {
        title: 'Products with Descriptions',
        icon: 'DescriptionIcon',
        color: '#f0f4c3',
        link: '/admin/products?filter=withDescriptions',
        btnLabel: 'View Products',
        key: 'productsWithDescriptionsCount',
    },
    {
        title: 'Recipes',
        icon: 'RestaurantIcon',
        color: '#ffebee',
        link: '/admin/recipes',
        btnLabel: 'Manage Recipes',
        key: 'recipesCount',
    },
    {
        title: 'Prices',
        icon: 'AttachMoneyIcon',
        color: '#e3f2fd',
        link: '/admin/prices',
        btnLabel: 'View Prices',
        key: 'pricesCount',
    },
    {
        title: 'Categories',
        icon: 'CategoryIcon',
        color: '#e5fbee',
        link: '/admin/categories',
        btnLabel: 'Manage Categories',
        key: 'categoriesCount',
    },
    {
        title: 'pgvector statistika',
        icon: 'StorageIcon',
        color: '#f2ecfa',
        key: 'pgvectorInfo',
        link: '/admin/pgvector',
        btnLabel: 'Tvarkyti pgvector',
    },
    {
        title: 'Open Food Facts',
        icon: 'RestaurantMenuIcon',
        color: '#fff3e0',
        key: 'openFoodFacts',
        link: '/admin/openfoodfacts',
        btnLabel: 'Tvarkyti Open Food Facts',
    },
];

const Admin: React.FC = () => {
    const { stats, loading, error } = useAdminStats();

    if (loading) {
        return <AdminLoading />;
    }

    return (
        <Box sx={{ maxWidth: 1200, mx: 'auto', py: 5, px: { xs: 2, sm: 3 } }}>
            <Typography variant="h3" component="h1" fontWeight={500} gutterBottom>
                Admin Dashboard
            </Typography>
            <Divider sx={{ mb: 4 }} />
            {error && <AdminError message={error} />}
            <Grid container spacing={4}>
                {statCardsConfig.map((config) => (
                    <Grid item xs={12} sm={6} md={4} key={config.key}>
                        <StatCard config={config} value={stats[config.key]} />
                    </Grid>
                ))}
            </Grid>
            <QuickLinks />
        </Box>
    );
};

export default Admin;